/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Actions/ProjectOverviewTabActionCreator" />
import { ActionsHub } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Actions/ActionsHub";
import { AboutProjectData } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Models";
import { PermissionsSource } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Sources/PermissionsSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class ProjectOverviewTabActionCreator {
    constructor(private _pageContext: IVssPageContext, private _actionsHub: ActionsHub, private _permissionsSource?: PermissionsSource) {}

    public loadPermissions = (): void => {
        const viewActivityPanePermission = this.permissionsSource.getViewActivityPanePermission();
        this._actionsHub.permissionsLoaded.invoke({ hasViewActivityPanePermission: viewActivityPanePermission });
    };

    private get permissionsSource(): PermissionsSource {
        if (!this._permissionsSource) {
            this._permissionsSource = new PermissionsSource(this._pageContext);
        }

        return this._permissionsSource;
    }
}
